import AxiosCustom from "../../../common/components/apiConfig";

export const confirm_offline_order_otp = (data) => {
  let config = { url: "update_request" };

  let _data = {
    table: "offlineorder",
    method_type: "confirm_offline_order_otp",
    data: {
      ...data,
    },
  };

  return AxiosCustom(config, _data);
};
